<section class="dialog-section">
  <div class="dialog-container">
    <div class="dialog-card">
      <!-- Header -->
      <div class="dialog-header">
        <h1 class="dialog-title">{{ "page.registration.title" | translate }}</h1>
        <p class="dialog-subtitle">{{ "page.registration.emailConfirmation.title" | translate }}</p>
      </div>

      <!-- Content -->
      <div class="dialog-content">
        <div class="image-container">
          <img src="app/shared/assets/images/mail_sent.svg" alt="Mail sent" class="dialog-image" />
        </div>

        <p class="dialog-description">
          {{ "page.registration.emailConfirmation.description" | translate: { email: data.email } }}
        </p>
      </div>

      <!-- Actions -->
      <div class="dialog-actions">
        <button class="secondary-button" (click)="close()">
          {{ "button.cancel" | translate }}
        </button>

        <button class="primary-button" (click)="resend()">
          {{ "button.resend" | translate }}
        </button>
      </div>
    </div>
  </div>
</section>
